import React from 'react'
import './SuppliersFeedback.css'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

const suppFeedbacks = [
    {
        supplierComment: "It's going to be amazing and such a brilliant idea- we would be honoured to be a part of it.",
        supplierName: "Prop Goes The Party"
    },
    {
        supplierComment: "Wow great idea. I have registered my interest as a supplier. Thank You ",
        supplierName: "Balloon Hub Melbourne"
    },
    {
        supplierComment: "Such a brilliant idea to come up with an app to connect suppliers with users directly, it makes life easier. Highly recommended.",
        supplierName: "Beyond Elegant By Sherry"
    },
    {
        supplierComment: "I am BEYOND excited for this app to kick off! How exciting and convenient to be able to source, organise, contact and confirm all of the businesses you want to use for your special event in one place!!",
        supplierName: "Two Little Cookies"
    },
]
const SuppliersFeedback = () => {
    
    return (
        <section className="SuppliersFeedback-contect-section">
            <div className="container">
                <div className="SuppliersFeedback-main-content">
                    <div className="SuppliersFeedback-info">
                        <h1 className="invisible-heading">FEEDBACK</h1>
                        <h2 className="visible-heading"><span className="heighlight">Suppliers Feedback</span></h2>
                        <p className="description">Check out what some amazing suppliers have said about the Elite Partyz app!</p>
                    </div>
                    <div className="Suppliers-Feedback-coontent">
                        <Carousel showThumbs={false} autoPlay={true} infiniteLoop={true} emulateTouch={true}>
                            {/* === Feedbacl Loop */
                                suppFeedbacks.map((feedback, feedbackNumber) => {
                                    return(
                                        <div className="feedback" key={`FEEDBACK${feedbackNumber}973873FGFAU`}>
                                            <p className="comment">{feedback.supplierComment}</p>
                                            <h4 className="feedback-author">{feedback.supplierName}</h4>
                                        </div>
                                    )
                                })
                            }
                        </Carousel>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SuppliersFeedback
